import { UnitsField } from "@imi-ernd-be/hyselect-engine";
import { withDelete } from "../helpers/withDelete";
import { toArray } from "../vector";

type SelectOptions<T> = {
  default: string;
  international: string;
  options: T[];
  type: "select";
};

export function unitsVectorToOptions(unitsField: UnitsField): SelectOptions<{
  default: boolean;
  id: string;
  label: string;
}> {
  const options = toArray(unitsField.getUnits()).map((unit) =>
    withDelete(unit, {
      default: unit.id === unitsField.getDefaultUnit().id,
      id: unit.id,
      label: unit.label,
    }),
  );
  return {
    default: unitsField.getDefaultUnit().id,
    international: unitsField.getInternationalUnit().id,
    options,
    type: "select",
  };
}
